<template>
  <a-card title="Dokumen">
    <a-button v-if="getAuth.divisi[0] == 'HRD' && data.profile.status=='Aktif'" slot="extra" @click="handleModalEdit()">Ubah Data</a-button>
    <a-row>
      <a-col :xs="{ span: 24}" :lg="{ span: 12 }">
        <div class="m-bottom">
          <h4 class="m-remove">Nama Sekolah / Universitas</h4>
          <span class="m-text-medium" v-if="data.dokumen">{{data.dokumen.nama_sekolah}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Alamat</h4>
          <span class="m-text-medium" v-if="data.dokumen" >{{data.dokumen.alamat_sekolah}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Kelas / Jenjang</h4>
          <span class="m-text-medium" v-if="data.dokumen">{{data.dokumen.kelas}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Jurusan</h4>
          <span class="m-text-medium" v-if="data.dokumen">{{data.dokumen.jurusan}}</span>
        </div>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <div class="m-bottom">
          <h4 class="m-remove">Guru / Dosen Pengantar</h4>
          <span class="m-text-medium" v-if="data.dokumen">{{data.dokumen.guru}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">No. Telp.</h4>
          <span class="m-text-medium" v-if="data.dokumen">{{data.dokumen.telp_sekolah}}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Dokumen Pendukung</h4>
          <span class="m-text-medium" v-if="data.dokumen">
            <a-button size="small" type="primary" @click="downloadFile">View Document</a-button>
          </span>
        </div>
      </a-col>
    </a-row>

    <a-modal :width="800" title="Edit Dokumen" :visible="visible" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="btnLoading" @click="handleOk">Submit</a-button>
      </template>
      <a-form class="m-form" :form="form">
        <a-row :gutter="8">
          <a-col span="12">
            <a-form-item label="Nama Sekolah / Universitas">
              <a-select v-decorator="[ 'id_sekolah', { rules: [{ required: true, message: 'Harus diisi!' }], initialValue: initial.id_sekolah }]"
                show-search :filter-option="filterOption" allowClear>
                <a-select-option v-for="item in data.master.sekolah" :key="item.id_sekolah">{{item.nama_sekolah}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Alamat">
              <a-input
                autocomplete="off"
                disabled
                v-decorator="['alamat_sekolah', {rules: [{required: true}], initialValue: initial.alamat_sekolah}]"
              />
            </a-form-item>
            <a-form-item label="No. Telp.">
              <a-input
                autocomplete="off"
                disabled
                v-decorator="['guru', {initialValue: initial.telp_sekolah}]"
              />
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="Kelas / Jenjang">
              <a-input
                autocomplete="off"
                v-decorator="['kelas', {rules: [{required: true}], initialValue: initial.kelas}]"
              />
            </a-form-item>
            <a-form-item label="Jurusan">
              <a-input
                autocomplete="off"
                v-decorator="['jurusan', {initialValue: initial.jurusan}]"
              />
            </a-form-item>
            <a-form-item label="Guru / Dosen Pengantar">
              <a-input
                autocomplete="off"
                v-decorator="['guru', {initialValue: initial.guru}]"
              />
            </a-form-item>
            <a-form-item label="Dokumen Pendukung">
              <a-upload
                class="d-block"
                accept="*"
                :showUploadList="true"
                :fileList="document"
                listType="text"
                :beforeUpload="beforeUpload"
                v-decorator="[
                  'doc',
                  { rules: [{ required: true }] },
                  { valuePropName: 'push' }
                ]"
              >
                <a-button>
                  <a-icon type="upload" />&nbsp; Select File
                </a-button>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import _ from "lodash";

export default {
  props: ["data"],
  data() {
    return {
      visible: false,
      btnLoading: false,
      document: []
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.$store.dispatch("Fetch_Bank");
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat"]),
    initial(){
      return this.data.dokumen ? this.data.dokumen : {}
    }
  },
  methods: {
    moment,
    handleModalEdit() {
      if(this.data.dokumen.document_support!='')
        this.convertUrlDokumenPendukung()
      this.visible = true;
    },
    handleCancel() {
      this.form.resetFields();
      this.visible = false;
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.confirmMessage("confirm-edit");
      });
    },
    submit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.btnLoading = true;
        let postData = new FormData();

        postData.append("id_siswa", this.data.profile.id_siswa);
        postData.append("id_sekolah", values.id_sekolah);
        postData.append("kelas", values.kelas);
        postData.append("jurusan", values.jurusan);
        postData.append("guru", values.guru);
        if(this.document)
        postData.append("document_support", this.document[0]);

        axios({
          method: "post",
          url: this.$serviceUrl + "internship/dokumen",
          processData: false,
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey
          }
        })
          .then(response => {
            this.displayMessage("success-edit");
            this.btnLoading = false;
            this.visible = false
            Event.$emit("fetching");
          })
          .catch(err => {
            this.btnLoading = false;
          });
      });
    },
    downloadFile(){
      window.open(this.$serviceUrl + this.data.dokumen.document_support, "_blank");
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    getformatCountrytelp(val){
      let res = ""
      if(val && val.length>=2){
        res = val.substring(0, 2);
      }
      return res
    },
    getformattelp(val){
      let res = ""
      if(val && val.length>2){
        res = val.substring(2);
      }
      return res
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file");
      } else {
        this.document = [file];
        return false;
      }
    },
    async convertUrlDokumenPendukung(){
      await axios({
        method: "get",
        url: this.$serviceUrl+"public_manifest/base_64",
        params:{
          path: this.data.dokumen.document_support
        },
      })
      .then((response) => {
        let typefile = this.fileTypeFromUrl(this.data.dokumen.document_support);
        let nama_file = this.data.dokumen.document_support.split("/")[4]
        let file = this.dataURLtoFile(
          typefile + response.data.file_document_tax,
          nama_file
        );
        file.uid = "vc-upload-1-1";
        file.status = "done";
        file.url = this.$serviceUrl + this.data.dokumen.document_support;

        this.document = []
        this.document.push(file)
        this.$nextTick(function () {
          this.form.setFieldsValue({
            doc: [file],
          });
        });
      })
      .catch((err) => {
        console.log(err)
      });
    }
  },
  mounted() {
    Event.$on("confirmMessageEdit", this.submit);
  },
  beforeDestroy() {
    Event.$off("confirmMessageEdit", this.submit);
  }
};
</script>

<style>
</style>
